import { NOTES_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const notesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all notes with pagination and keyword search
    getNotes: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: NOTES_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Notes'],
    }),

    // Fetch a single note by ID
    getNoteDetails: builder.query({
      query: (noteId) => ({
        url: `${NOTES_URL}/${noteId}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Create a new note
    createNote: builder.mutation({
      query: (data) => ({
        url: NOTES_URL,
        method: 'POST',
        body: data, // Pass the note data (e.g., date, status, details, etc.)
      }),
      invalidatesTags: ['Notes'], // Refresh notes cache
    }),

    // Update an existing note
    updateNote: builder.mutation({
      query: (data) => ({
        url: `${NOTES_URL}/${data.noteId}`,
        method: 'PUT',
        body: data, // Includes fields like images, date, status, etc.
      }),
      invalidatesTags: ['Notes'], // Refresh notes cache
    }),

    // Upload images for notes
    uploadNoteImages: builder.mutation({
      query: (data) => ({
        url: `/api/upload`, // Backend endpoint for uploading images
        method: 'POST',
        body: data, // FormData object containing multiple images
      }),
    }),

    // Delete a specific note by ID
    deleteNote: builder.mutation({
      query: (noteId) => ({
        url: `${NOTES_URL}/${noteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notes'], // Refresh notes cache
    }),

    // Create a review for a specific note
    createReview: builder.mutation({
      query: (data) => ({
        url: `${NOTES_URL}/${data.noteId}/reviews`,
        method: 'POST',
        body: data, // Includes rating and comment fields
      }),
      invalidatesTags: ['Notes'], // Refresh notes cache
    }),

    // Fetch the top-rated notes
    getTopNotes: builder.query({
      query: () => `${NOTES_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});

// Exporting hooks for all the endpoints
export const {
  useGetNotesQuery,
  useGetNoteDetailsQuery,
  useCreateNoteMutation,
  useUpdateNoteMutation,
  useUploadNoteImagesMutation,
  useDeleteNoteMutation,
  useCreateReviewMutation,
  useGetTopNotesQuery,
} = notesApiSlice;